import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, FormGroup, Label, Input } from 'reactstrap';

interface DeleteVisitModalProps {
  isOpen: boolean;
  toggle: () => void;
  onConfirm: (reason: string, explain_reason: string, status: string) => void;
  reasons: string[];
}

const DeleteVisitModal: React.FC<DeleteVisitModalProps> = ({ isOpen, toggle, onConfirm, reasons }) => {
  const [reason, setReason] = useState('');
  const [explainReason, setExplainReason] = useState('');
  const [status, setStatus] = useState('');

  const handleConfirm = () => {
    if (!reason) return;
    onConfirm(reason, explainReason, status);
    setReason('');
    setExplainReason('');
    setStatus('');
    toggle();
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} className="modal-dialog-centered">
      <ModalHeader toggle={toggle}>Eliminar visita</ModalHeader>
      <ModalBody>
        <FormGroup>
          <Label for="delete-status">Estado</Label>
          <Input
            type="select"
            id="delete-status"
            value={status}
            onChange={e => setStatus(e.target.value)}
          >
            <option value="">Cancelada</option>
            <option value="voided">Anulada</option>
          </Input>
        </FormGroup>
        <FormGroup>
          <Label for="delete-reason">Motivo</Label>
          <Input
            type="select"
            id="delete-reason"
            value={reason}
            onChange={e => setReason(e.target.value)}
          >
            <option value="">Selecciona un motivo</option>
            {reasons.map(r => (
              <option key={r} value={r}>{r}</option>
            ))}
          </Input>
        </FormGroup>
        <FormGroup>
          <Label for="delete-explain">Comentario adicional</Label>
          <Input
            type="textarea"
            id="delete-explain"
            value={explainReason}
            onChange={e => setExplainReason(e.target.value)}
            placeholder="Agrega un comentario (opcional)"
            rows={3}
          />
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>Cancelar</Button>
        <Button color="danger" onClick={handleConfirm} disabled={!reason}>
          Eliminar visita
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default DeleteVisitModal;